import React, { Suspense } from "react";
import { Navigate, Outlet } from "react-router";
import Cookie from "js-cookie";
import LoadingComponent from "@/components/Loading/loadingComponent";
import EmptyLayout from "@/components/AppLayout/EmptyLayout/EmptyLayout";
import MainLayout from "@/components/AppLayout/MainLayout/MainLayout";

/**
 * Layout routes. Each wraps its matched children via <Outlet />, so a group of
 * routes declares a concern once instead of repeating it on every route.
 */

/** Lazy route components need a boundary; one per group is enough. */
export const SuspenseOutlet = () => (
  <Suspense
    fallback={
      // Tagged so route tests can tell "the chunk is still downloading" apart
      // from "the page is loading its data" — both render LoadingComponent.
      <div data-testid="route-suspense">
        <LoadingComponent />
      </div>
    }
  >
    <Outlet />
  </Suspense>
);

/** Sends anonymous visitors to login, remembering where they came from. */
export const ProtectedOutlet = () => {
  const isLoggedIn = !!Cookie.get("token");

  if (!isLoggedIn) {
    sessionStorage.setItem(
      "scrollDetails",
      JSON.stringify({
        from: "protectedRoute",
        path: "/auth/login",
        previousPath: window.location.pathname,
      })
    );
    return <Navigate to="/auth/login" replace />;
  }

  return <Outlet />;
};

export const EmptyLayoutOutlet = () => (
  <EmptyLayout>
    <SuspenseOutlet />
  </EmptyLayout>
);

export const MainLayoutOutlet = () => (
  <MainLayout>
    <SuspenseOutlet />
  </MainLayout>
);
